<template>
  <div class="pb-item-properties">
    <slot />
  </div>
</template>

<style lang="scss" src="./ItemProperties.scss" />
